import * as pdfjsLib from "pdfjs-dist";

pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

async function renderPdfPageThumbnail(pdfData, maxWidth = 80) {
  const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
  const page = await pdf.getPage(1);

  const viewport = page.getViewport({ scale: 1 });
  const scale = maxWidth / viewport.width;
  const scaledViewport = page.getViewport({ scale });

  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  canvas.width = scaledViewport.width;
  canvas.height = scaledViewport.height;

  await page.render({ canvasContext: context, viewport: scaledViewport })
    .promise;

  return canvas.toDataURL("image/jpeg", 0.85);
}

/**
 * Renderiza páginas de un PDF a JPEG (alta resolución para export).
 */
export async function renderPdfPagesFromBase64(
  base64Data,
  maxDim = 2200,
  maxPages = Infinity,
) {
  const pdfData = Uint8Array.from(atob(base64Data), (c) => c.charCodeAt(0));
  const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
  const pages = [];
  const pageCount = Math.min(pdf.numPages, Math.max(0, maxPages));

  for (let pageNum = 1; pageNum <= pageCount; pageNum += 1) {
    const page = await pdf.getPage(pageNum);
    const baseViewport = page.getViewport({ scale: 1 });
    const scale = Math.min(
      maxDim / baseViewport.width,
      maxDim / baseViewport.height,
      2.5,
    );
    const viewport = page.getViewport({ scale });
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    canvas.width = Math.max(1, Math.floor(viewport.width));
    canvas.height = Math.max(1, Math.floor(viewport.height));

    // Fondo blanco (PDFs con transparencia)
    context.fillStyle = "#ffffff";
    context.fillRect(0, 0, canvas.width, canvas.height);

    await page.render({ canvasContext: context, viewport }).promise;

    pages.push({
      dataUrl: canvas.toDataURL("image/jpeg", 0.92),
      format: "JPEG",
      mimeType: "image/jpeg",
      width: canvas.width,
      height: canvas.height,
    });
  }

  return pages;
}

export async function renderPdfThumbnailFromBase64(base64Data, maxWidth = 80) {
  const pdfData = Uint8Array.from(atob(base64Data), (c) => c.charCodeAt(0));
  return renderPdfPageThumbnail(pdfData, maxWidth);
}

export async function renderPdfThumbnailFromBlob(blob, maxWidth = 80) {
  const pdfData = new Uint8Array(await blob.arrayBuffer());
  return renderPdfPageThumbnail(pdfData, maxWidth);
}
